import { Route, Routes } from "react-router-dom";

import { Provider as JotaiProvider } from "jotai";

import { AppMantineProvider, AppShell } from "@prostocheck/controls-web";
import { SessionProvider, useDocumentLanguage } from "@prostocheck/data-web";
import {
  BusinessUnitsPage,
  CashRegisterPage,
  CashRegistersPage,
  DashboardPage,
  ExtensionGuidePage,
  LoginPage,
  NotFoundPage,
} from "@prostocheck/pages-web";

import { IAppProps } from "./app.models";
import { BackgroundHooks } from "./background-hooks";
import { RequireSession } from "./require-session";

export const App = ({ initialSession = null }: IAppProps) => {
  useDocumentLanguage();

  return (
    <JotaiProvider>
      <AppMantineProvider>
        <SessionProvider initialSession={initialSession}>
          <BackgroundHooks />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/extension" element={<ExtensionGuidePage />} />

            <Route
              element={
                <RequireSession>
                  <AppShell />
                </RequireSession>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="registers" element={<CashRegistersPage />} />
              <Route
                path="registers/:cashRegisterFn"
                element={<CashRegisterPage />}
              />
              <Route path="business-units" element={<BusinessUnitsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </SessionProvider>
      </AppMantineProvider>
    </JotaiProvider>
  );
};
